module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BonusClubValuePrinter":{"anonymousUser":"pro přihlášené","tooltip":"Zaregistrujte se a získejte ve věrnostním programu za každých 100 Kč investovaných do zpestření sexu 10 Kč zpět na další nákupy."}},"en":{}}')
  delete Component.options._Ctor
}
